
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schedule/[categorySlug]",
      function () {
        return require("private-next-pages/schedule/[categorySlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schedule/[categorySlug]"])
      });
    }
  